import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../apiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";


const AdminEventos = () => {
  const [eventos, setEventos] = useState([]);
  const [showModalCrear, setShowModalCrear] = useState(false);
  const [showModalEditar, setShowModalEditar] = useState(false);
  const [showModalAsignar, setShowModalAsignar] = useState(false);
  const [eventoActual, setEventoActual] = useState(null);
  const [nombreEvento, setNombreEvento] = useState("");
  const [descripcionEvento, setDescripcionEvento] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [meta, setMeta] = useState(0);
  const [metaError, setMetaError] = useState(false);
  const [estatusEvento, setEstatusEvento] = useState("Activo");
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const [showEditarModal, setShowEditarModal] = useState(false);
  const [showAsignarModal, setShowAsignarModal] = useState(false);
  const [lideresDisponibles, setLideresDisponibles] = useState([]);
  const [lideresAsignados, setLideresAsignados] = useState([]);
  const [eventoIdSeleccionado, setEventoIdSeleccionado] = useState(null);
  const [EvidenciaCheck, setEvidenciaCheck] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const eventosPorPagina = 3; //
  const totalPaginas = Math.ceil(eventos.length / eventosPorPagina);
  const navigate = useNavigate();
  const [showAsignarPorNivelModal, setShowAsignarPorNivelModal] = useState(false);
  const [niveles, setNiveles] = useState([]);
  const [nivelesSeleccionados, setNivelesSeleccionados] = useState([]);
  const [eventosMasivos, setEventosMasivos] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);



{/**
  const cargarEventos = async () => {
    // Código para cargar eventos
    let eventosCargados = await fetchEventos();
    // Verifica que eventosCargados sea un array antes de llamar a sort
    if (Array.isArray(eventosCargados) && eventosCargados.length > 0) {
      // Ordenas los eventos por fecha de inicio, de más reciente a más antiguo
      eventosCargados.sort((a, b) => new Date(b.fechaInicio) - new Date(a.fechaInicio));
      setEventos(eventosCargados);
    } else {
      console.log("No se cargaron eventos o no son un array");
    }
  };

  cargarEventos();
*/}


  const fetchEventos = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Eventos/ListaEventos`);
    // Asegúrate de ordenar aquí los eventos una vez obtenidos
    const eventosOrdenados = response.data.sort((a, b) => new Date(b.fechaAlta) - new Date(a.fechaAlta));
    setEventos(eventosOrdenados);
    } catch (error) {
      console.error("Error al obtener eventos:", error);
      alert("Error al cargar eventos.");
    }
  };

  const fetchNiveles = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Lider/ListarNiveles`);
      setNiveles(response.data);
    } catch (error) {
      console.error("Error al obtener niveles:", error);
    }
  };


  useEffect(() => {
    fetchEventos();
    fetchNiveles();
  }, []);



  const inicioIndex = (paginaActual - 1) * eventosPorPagina;
  const eventosOrdenados = [...eventos].sort((a, b) => new Date(b.fechaInicio) - new Date(a.fechaInicio));
  const eventosMostrados = eventos.slice(inicioIndex, inicioIndex + eventosPorPagina);

  const abrirModalCrear = () => {
    setNombreEvento("");
    setDescripcionEvento("");
    setFechaInicio("");
    setFechaFin("");
    setMeta(0);
    setEstatusEvento("Activo");
    setShowModalCrear(true);
  };


  const manejarCreacionEvento = async () => {
    if (!meta || meta < 1) {
    setMetaError(true);
    toast.warning("La meta debe ser mayor.", {
      position: "top-center",
      autoClose: 4000,
      theme: "light",
      style: {
        backgroundColor: "#081b29",
        color: "#",
        borderRadius: "8px",
      },
    });
    return;
  }
    try {
      const nuevoEvento = {
        nombreEvento,
        descripcionEvento,
        fechaInicio,
        fechaFin,
        meta,
        estatusEvento,
        EvidenciaCheck,
        eventosMasivos, //  Nuevo campo agregado
      };
      await axios.post(`${API_BASE_URL}/Eventos/CrearEvento`, nuevoEvento);
      // Cerrar modal y resetear campos aquí
    setShowModalCrear(false);
    setNombreEvento("");
    setDescripcionEvento("");
    setFechaInicio("");
    setFechaFin("");
    setMeta(0);
    setEstatusEvento("Activo");
    setEvidenciaCheck(false); // Asumiendo que quieres también resetear esto
    setEventosMasivos(false); // Igual para este campo si es necesario
    fetchEventos();
    // Opcionalmente, mostrar un mensaje de éxito
    toast.success("Evento creado con éxito!", {
      position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
              backgroundColor: "#081b29",
              color: "#ffffff",
              fontWeight: "bold",
              borderRadius: "8px",
          }
    });
  } catch (error) {
    console.error("Error al crear evento:", error);
    toast.error("Por favor revisa los datos de la fecha", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
          style: {
              backgroundColor: "#081b29",
              color: "#ffffff",
              fontWeight: "bold",
              borderRadius: "8px",
          }
    });
  }
};


  const manejarEdicionEvento = async () => {
    try {
      const eventoEditado = {
        id: eventoActual.id,
        nombreEvento,
        descripcionEvento,
        fechaInicio,
        fechaFin,
        meta,
        estatusEvento,
        EvidenciaCheck: eventoSeleccionado.EvidenciaCheck, //  Nuevo campo agregado
        eventosMasivos: eventoSeleccionado.eventosMasivos, //  Nuevo campo agregado
      };
      await axios.post(`${API_BASE_URL}/Eventos/EditarEvento`, eventoEditado);
      setShowModalEditar(false);
      fetchEventos();
    }
    catch (error) {
      console.error("Error al editar evento:", error);
      toast.error(" Error al editar evento.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: { backgroundColor: "#D32F2F", color: "#FFFFFF", borderRadius: "8px" },
      });
    }

  };



const abrirModalEditar = async (id) => {
  try {
      const response = await axios.get(`${API_BASE_URL}/Eventos/Evento/${id}`);
      console.log("Evento recibido para edición:", response.data);
      const evento = response.data;

      // Transformamos las fechas al formato adecuado para los inputs
      evento.FechaInicio = evento.fechaInicio ? evento.fechaInicio.slice(0, 16) : "";
      evento.FechaFin = evento.fechaFin ? evento.fechaFin.slice(0, 16) : "";


      if (evento.estatusEvento === "Finalizado") {
        toast.warning(" No se puede editar un evento finalizado.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#081b29", color: "#FFFFFF", borderRadius: "8px" },
        });
        return;
      }


      setEventoSeleccionado({
          ...evento,
          EvidenciaCheck: evento.evidenciaCheck ?? false, // Se asigna correctamente al estado
      });

      setShowEditarModal(true);
  } catch (error) {
      console.error("Error al obtener el evento:", error);
      alert("Error al obtener la información del evento.");
  }
};


const guardarEdicionEvento = async () => {
  if (!eventoSeleccionado.meta || parseInt(eventoSeleccionado.meta) < 1) {
  setMetaError(true);
    toast.warning("La meta debe ser mayor o igual a 1.", {
      position: "top-center",
      autoClose: 4000,
      theme: "light",
      style: {
        backgroundColor: "#081b29",
        color: "#",
        borderRadius: "8px",
      },
    });
    return;
}

  try {
    const response = await axios.post(`${API_BASE_URL}/Eventos/EditarEvento`, eventoSeleccionado);
    Swal.fire({
      title: '¡Éxito!',
      text: 'El evento ha sido actualizado correctamente.',
      icon: 'success',
      confirmButtonColor: '#3085d6',
      background: "#081b29",
      color: "#ffffff",
    });
    setShowEditarModal(false);
    fetchEventos(); // Recarga la lista de eventos
  } catch (error) {
    console.error("Error al actualizar el evento:", error);
    let errorMessage = "Error al actualizar el evento.";

    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    }

    Swal.fire({
      title: 'Error',
      text: errorMessage,
      icon: 'error',
      confirmButtonColor: '#d33',
      background: "#081b29",
      color: "#ffffff",
    });
  }
};


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ELIMINAR EVENTOS DE ADMINEVENTOS /////////////////////////////////////////////////

const eliminarEvento = async (id) => {
  try {
    const eventoResponse = await axios.get(`${API_BASE_URL}/Eventos/Evento/${id}`);
    const evento = eventoResponse.data;



    if (evento.estatusEvento === "Finalizado") {
      toast.warning(" No se puede eliminar un evento finalizado.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: { backgroundColor: "#081b29", color: "#FFFFFF", borderRadius: "8px" },
      });
      return;
    }

    // Usando SweetAlert2 para confirmación
    const result = await Swal.fire({
      title: '¿Estás seguro que deseas eliminar este evento?',
      //text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      background: "#081b29",
      color: "#ffffff",
    });

    if (!result.isConfirmed) {
      return;
    }

    // ENVIAMOS LA PETICIÓN DE ELIMINACIÓN
    const response = await axios.post(`${API_BASE_URL}/Eventos/EliminarEvento?id=${id}`);
    Swal.fire({
      title: 'Eliminado',
      text: 'El evento ha sido eliminado correctamente.',
      icon: 'success',
      background: "#081b29", // Cambia el color de fondo (ejemplo: azul oscuro)
      color: "#ffffff", // Cambia el color del texto a blanco
      confirmButtonColor: "#3085d6",
    });

    // REFRESCAMOS LA LISTA DE EVENTOS
    fetchEventos();
  } catch (error) {
    console.error("Error al eliminar el evento:", error);
    const errorMessage = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : "Error al intentar eliminar el evento.";

    Swal.fire({
      title: 'Error',
      text: errorMessage,
      icon: 'error',
      confirmButtonColor: '#d33',
      background: "#d32f2f",
      color: "#ffffff",
    });
  }
};


{/*
const eliminarEvento = async (id) => {
  try {
    // PRIMERO OBTENEMOS EL EVENTO POR SU ID
    const eventoResponse = await axios.get(`${API_BASE_URL}/Eventos/Evento/${id}`);
    const evento = eventoResponse.data;

    // SI EL EVENTO ESTÁ FINALIZADO, NO PERMITIR ELIMINACIÓN
    if (evento.estatusEvento === "Finalizado") {
      toast.error("No se puede eliminar un evento finalizado.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        //theme: "#1e293b", // Tema de color para mejor contraste
        style: { backgroundColor: "#1e293b", color: "#ffffff", borderRadius: "8px" },
      });
      return;
    }

    // Usando SweetAlert2 para confirmación
    const result = await Swal.fire({
      title: '¿Estás seguro que deseas eliminar este evento?',
      //text: "¿Deseas eliminar este evento?",
      //icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      background: "#081b29", // Cambia el color de fondo (ejemplo: azul oscuro)
      color: "#ffffff",
    });


    // ENVIAMOS LA PETICIÓN DE ELIMINACIÓN
    const response = await axios.post(`${API_BASE_URL}/Eventos/EliminarEvento?id=${id}`); // Usar método DELETE si es posible
    toast.success(response.data.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored", // Tema de color para coherencia
      style: { backgroundColor: "#2e7d32", color: "#ffffff", borderRadius: "8px" },
    });

    // REFRESCAMOS LA LISTA DE EVENTOS
    fetchEventos();
  } catch (error) {
    console.error("Error al eliminar el evento:", error);

    const errorMessage = error.response && error.response.status === 400
      ? " No se puede eliminar un evento finalizado."
      : " Error al intentar eliminar el evento.";

    toast.error(errorMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored", // Tema de color para error
      style: { backgroundColor: "#d32f2f", color: "#ffffff", borderRadius: "8px" },
    });
  }
};
*/}



  const abrirModalAsignarPorNivel = async (id) => {
    setEventoIdSeleccionado(id);

    try {
      // Obtener la información del evento
      const eventoResponse = await axios.get(`${API_BASE_URL}/Eventos/Evento/${id}`);
      const evento = eventoResponse.data;
      console.log("Evento recibido para asignación por nivel:", evento);

      //  Verificar si el evento está finalizado
      if (evento.estatusEvento === "Finalizado") {
        toast.warning(" No se puede asignar líderes por nivel a un evento finalizado.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#081b29", color: "#FFFFFF", borderRadius: "8px" },
        });
        return;
      }

      // Si pasa la validación, abrir el modal
      setNivelesSeleccionados([]);
      setShowAsignarPorNivelModal(true);

    } catch (error) {
      console.error("Error al obtener la información del evento:", error);
      alert("Hubo un error al obtener los datos del evento.");
    }
  };


  const toggleNivel = (nivelId) => {
    setNivelesSeleccionados((prev) =>
      prev.includes(nivelId) ? prev.filter(id => id !== nivelId) : [...prev, nivelId]
    );
  };

  const guardarAsignacionPorNivel = async () => {
    if (nivelesSeleccionados.length === 0) {
      Swal.fire({
        title: 'Selecciona al menos un nivel.',
        //text: 'Selecciona al menos un nivel.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        background: "#081b29",
        color: "#ffffff",
      });
      return;
    }

    console.log("📢 Enviando al backend:", {
      EventoId: eventoIdSeleccionado,
      Niveles: nivelesSeleccionados,
    });

    try {
      const response = await axios.post(`${API_BASE_URL}/Eventos/AsignarEventoPorNivel`, {
        EventoId: eventoIdSeleccionado,
        Niveles: nivelesSeleccionados,
      });

      Swal.fire({
        title: 'Éxito',
        text: response.data.message,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        background: "#081b29",
        color: "#ffffff",
      });
      setShowAsignarPorNivelModal(false);
    } catch (error) {
      console.error("Error al asignar líderes por nivel:", error);
      Swal.fire({
        //title: 'Error',
        text: 'Error, no existen líderes en este nivel',
        icon: 'error',
        confirmButtonColor: '#d33',
        background: "#081b29",
        color: "#ffffff",
      });
    }
  };

  ///  ABRIR MODAL DE ASIGNACIÓN
const abrirModalAsignar = async (id) => {
  setEventoIdSeleccionado(id);
  try {
      // Obtener la información del evento
      const eventoResponse = await axios.get(`${API_BASE_URL}/Eventos/Evento/${id}`);
      const evento = eventoResponse.data;
      console.log("Evento recibido para asignación:", evento);

      if (evento.estatusEvento === "Finalizado") {
        toast.warning(" No se puede asignar líderes a un evento finalizado.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#081b29", color: "#FFFFFF", borderRadius: "8px" },
        });
        return;
      }

      // Obtener líderes asignados y disponibles
      const lideresResponse = await axios.get(`${API_BASE_URL}/Eventos/LideresPorEvento?eventoId=${id}`);
      console.log("Líderes recibidos:", lideresResponse.data);

      const disponibles = lideresResponse.data.filter(lider => !lider.asignado);
      const asignados = lideresResponse.data.filter(lider => lider.asignado);

      setLideresDisponibles(disponibles);
      setLideresAsignados(asignados);
      setShowAsignarModal(true);

  } catch (error) {
      console.error("Error al obtener la información:", error);
      Swal.fire("Error", "Hubo un error al obtener los datos del evento.", "error");
  }
};


  const moverLider = (id, deLista, aLista) => {
    const liderMovido = deLista.find(lider => lider.id === id);
    if (!liderMovido) return;

    setLideresDisponibles(prev => prev.filter(lider => lider.id !== id));
    setLideresAsignados(prev => prev.filter(lider => lider.id !== id));

    if (aLista === "asignados") setLideresAsignados(prev => [...prev, liderMovido]);
    else setLideresDisponibles(prev => [...prev, liderMovido]);
  };

  //  Mueve todos los líderes entre listas
  const moverTodos = (deLista, aLista) => {
    if (deLista === "disponibles") {
      setLideresAsignados(prev => [...prev, ...lideresDisponibles]);
      setLideresDisponibles([]);
    } else {
      setLideresDisponibles(prev => [...prev, ...lideresAsignados]);
      setLideresAsignados([]);
    }
  };

  const guardarAsignacion = async () => {
    try {
      const lideresIds = lideresAsignados.map(lider => lider.id);
      const response = await axios.post(`${API_BASE_URL}/Eventos/AsignarLideres`, {
        EventoId: eventoIdSeleccionado,
        Lideres: lideresIds,
      });


    Swal.fire({
      title: "Asignación Completada",
      //text: response.data.message, MENSAJE DESDE EL BACK
      icon: "success",
      confirmButtonColor: "#3085d6", // Color del botón de confirmación
      background: "#081b29",
      color: "#ffffff",
      customClass: {
      popup: 'custom-popup-class' // Clase CSS para más personalización
      }
    });
    setShowAsignarModal(false);
  } catch (error) {
    console.error("Error al asignar líderes:", error);
    Swal.fire({
      title: "Error",
      text: "Error al asignar líderes al evento.",
      icon: "error",
      confirmButtonColor: "#d33", // Color del botón de error
      background: "#7f8c8d", // Gris oscuro como color de fondo
      color: "#ecf0f1", // Texto claro para contraste
      customClass: {
        popup: 'custom-error-popup-class' // Clase CSS para errores
      }
    });
  }
};


  const quitarLiderDelEvento = async () => {
  if (!eventoIdSeleccionado) {
    Swal.fire("Atención", "Selecciona un evento.", "info");
    return;
  }

  const lideresIds = lideresAsignados.map(lider => lider.id);
  if (lideresIds.length === 0) {
    Swal.fire("Atención", "No hay líderes asignados para eliminar.", "info");
    return;
  }
  try {
    const response = await axios.post(`${API_BASE_URL}/Eventos/EliminarLiderDelEvento`, {
      EventoId: eventoIdSeleccionado,
      Lideres: lideresIds
    });

    Swal.fire("Líderes Eliminados", response.data.message, "success");
    abrirModalAsignar(eventoIdSeleccionado);
  } catch (error) {
    console.error("Error al quitar líderes:", error);
    Swal.fire("Error", "Error al quitar líderes del evento.", "error");
  }
};

  //////////////////////////DETALLEEEESSSSSSS/////////////////////////////////
  return (

        <div className="container mt-5 text-center">
          <img src="/img/monytorlogoa.png" alt="Logo" className="login-image" />

        <h2>Administración de Eventos</h2>

        {/*  Mostrar total de eventos*/}
        <h4 className="mt-3 text-white px-4 py-2 rounded-lg inline-block">
          Total de eventos: {eventos.length}
        </h4>


        <button className="btn btn-success mb-3 ml-3" onClick={() => setShowModalCrear(true)}>
          Nuevo Evento
        </button>

        <button className="btn transition ml-2" onClick={() => navigate("/administradorMenu")}>
          Regresar al Menú
        </button>


        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Meta</th>
              <th>Estatus</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {eventosMostrados.length > 0 ? (
              [...eventosMostrados]
              .sort((a, b) => new Date(b.fechaInicio) - new Date(a.fechaInicio))
              .map((evento) => (
                  <tr key={evento.id} className="text-center">
                    <td className="w-[150px] px-4 py-2 border">{evento.nombreEvento}</td>
                    <td className="w-[150px] px-4 py-2 border">{evento.descripcionEvento}</td>
                    <td className="w-[150px] px-4 py-2 border">{evento.fechaInicio}</td>
                    <td className="w-[150px] px-4 py-2 border">{evento.fechaFin}</td>
                    <td className="w-[80px] px-4 py-2 border">{evento.meta}</td>
                    <td className="w-[150px] px-4 py-2 border">{evento.estatusEvento}</td>
                    <td className="w-[150px] px-4 py-2 border">
                      <div className="flex justify-center items-center gap-4">
                      <div className="relative group">
                        <img
                          src="img/icoeditar.png"
                          alt="Editar evento"
                          className="w-10 h-10 cursor-pointer transition-transform transform hover:scale-110"
                          onClick={() => abrirModalEditar(evento.id)}
                        />
                        <span className="tooltip">Editar</span>
                      </div>

                        <div className="relative group">
                          <img
                            src="img/icoeliminar.png"
                            alt="Eliminar evento"
                            className="w-10 h-10 cursor-pointer transition-transform transform hover:scale-110"
                            onClick={() => eliminarEvento(evento.id)}
                          />
                          <span className="tooltip">Eliminar</span>
                        </div>

                        <div className="relative group">
                          <img
                            src="img/icoasignar.png"
                            alt="Asignar Líderes"
                            className="w-10 h-10 cursor-pointer transition-transform transform hover:scale-110"
                            onClick={() => abrirModalAsignar(evento.id)}
                          />
                          <span className="tooltip">Asignar Líderes</span>
                        </div>

                        <div className="relative group">
                          <img
                            src="img/icoasignar.png"
                            alt="Asignar por Nivel"
                            className="w-10 h-10 cursor-pointer transition-transform transform hover:scale-110"
                            onClick={() => abrirModalAsignarPorNivel(evento.id)}
                          />
                          <span className="tooltip">Asignar por Nivel</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-gray-500">No hay eventos registrados.</td>
              </tr>
            )}
          </tbody>
        </table>

        {/*  PAGINACIÓN */}
        {totalPaginas > 1 && (
          <div className="flex justify-center mt-4 gap-2">
            <button
              className={`px-3 py-1 rounded ${
                paginaActual === 1 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
              }`}
              onClick={() => setPaginaActual(paginaActual - 1)}
              disabled={paginaActual === 1}
            >
              ◀ Anterior
            </button>

            {[...Array(totalPaginas)].map((_, index) => (
              <button
                key={index}
                className={`px-3 py-1 rounded ${
                  paginaActual === index + 1 ? "bg-white text-black font-bold" : "bg-gray-500 hover:bg-gray-600"
                }`}
                onClick={() => setPaginaActual(index + 1)}
              >
                {index + 1}
              </button>
            ))}

            <button
              className={`px-3 py-1 rounded ${
                paginaActual === totalPaginas ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
              }`}
              onClick={() => setPaginaActual(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
            >
              Siguiente ▶
            </button>
          </div>
        )}

        {/* MODAL CREAR EVENTO  */}

        {showModalCrear && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    //onClick={() => setShowModalCrear(false)}
  >
    <div
      className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full text-black relative max-h-screen overflow-y-auto"
      style={{
        //IMAGEN A FUTURO
    //backgroundImage: 'url("/img/logoazul.png")',
    backgroundSize: '150px',
    backgroundPosition: 'center',
  }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="text-lg font-semibold text-gray-800">Crear Evento</h3>
        <button
          onClick={() => setShowModalCrear(false)}
          className="text-gray-600 hover:text-black text-xl"
        >
          ✖
        </button>
      </div>

      {/* Cuerpo del Modal */}
      <div className="mt-4 space-y-3">
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded"
          placeholder="Nombre del evento"
          value={nombreEvento}
          onChange={(e) => setNombreEvento(e.target.value)}
          requerid
        />

        <textarea
          className="w-full p-2 border border-gray-300 rounded resize-none"
          placeholder="Propósito definido"
          rows="3"
          value={descripcionEvento}
          onChange={(e) => setDescripcionEvento(e.target.value)}
          requerid
        >
        </textarea>

        <label className="block text-gray-700 text-sm">Fecha de Inicio:</label>
        <input
          type="datetime-local"
          className="w-full p-2 border border-gray-300 rounded"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          requerid
        />

        <label className="block text-gray-700 text-sm">Fecha de Fin:</label>
        <input
          type="datetime-local"
          className="w-full p-2 border border-gray-300 rounded"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          requerid
        />

        <label className="block text-gray-700 text-sm">Meta:</label>
        <input
          type="number"
          min={1} // 👈 Establece 1 como el valor mínimo permitido
          className="w-full p-2 border border-gray-300 rounded"
          placeholder="Meta del evento"
          value={meta}
          onChange={(e) => {
            const valor = parseInt(e.target.value, 10);
            if (!isNaN(valor) && valor >= 1) {
              setMeta(valor);
            } else if (e.target.value === "") {
              setMeta("");
            }
          }}
        />


        <div className="flex items-center mt-2">
          <input
            type="checkbox"
            id="EvidenciaCheck"
            className="mr-2"
            checked={EvidenciaCheck}
            onChange={(e) => setEvidenciaCheck(e.target.checked)}
            disabled={eventosMasivos} //  Se deshabilita si "Eventos Masivos" está seleccionado
          />
          <label htmlFor="EvidenciaCheck" className="text-gray-700">
            ¿Requiere Evidencia?
          </label>
        </div>

        {/*  Checkbox de "Evento Masivo" */}
        <div className="flex items-center mt-2">
          <input
            type="checkbox"
            id="EventosMasivos"
            className="mr-2"
            checked={eventosMasivos}
            onChange={(e) => setEventosMasivos(e.target.checked)}
            disabled={EvidenciaCheck} //  Se deshabilita si "Requiere Evidencia" está seleccionado
          />
          <label htmlFor="EventosMasivos" className="text-gray-700">
            ¿Es un Evento Masivo?
          </label>
        </div>



      </div>

      {/* Botones de Acción */}
      <div className="mt-6 flex justify-end gap-2">
        <button
          className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
          onClick={manejarCreacionEvento}
        >
          Guardar
        </button>
        <button
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition"
          onClick={() => setShowModalCrear(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}


 {/* MODAL EDITAR EVENTO  */}
 {showEditarModal && eventoSeleccionado && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    //onClick={() => setShowEditarModal(false)}
  >
    <div
      className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full text-black relative max-h-screen overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="text-lg font-semibold text-gray-800">Editar Evento</h3>
        <button
          onClick={() => setShowEditarModal(false)}
          className="text-gray-600 hover:text-black text-xl"
        >
          ✖
        </button>
      </div>

      {/* Cuerpo del Modal */}
      <div className="mt-4 space-y-3">
        <label className="block text-gray-700 text-sm">Nombre del Evento</label>
        <input
          type="text"
          className="w-full p-2 border border-gray-300 rounded"
          value={eventoSeleccionado?.nombreEvento || ""}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, nombreEvento: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        />

        <label className="block text-gray-700 text-sm">Reglas de Participación</label>
        <textarea
          className="w-full p-2 border border-gray-300 rounded resize-none"
          rows="3"
          value={eventoSeleccionado?.descripcionEvento || ""}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, descripcionEvento: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        ></textarea>

        {/* <label className="block text-gray-700 text-sm">Fecha de Inicio</label>
        <input
          type="datetime-local"
          className="w-full p-2 border border-gray-300 rounded"
          value={eventoSeleccionado?.FechaInicio || ""}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, FechaInicio: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        /> */}
        <label className="block text-gray-700 text-sm">Fecha de Inicio</label>
        <input
          type="datetime-local"
          className="w-full p-2 border border-gray-300 rounded bg-gray-200 cursor-not-allowed"
          value={eventoSeleccionado?.FechaInicio || ""}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, FechaInicio: e.target.value })
          }
          disabled
        />

        <label className="block text-gray-700 text-sm">Fecha de Fin</label>
        <input
          type="datetime-local"
          className="w-full p-2 border border-gray-300 rounded"
          value={eventoSeleccionado?.FechaFin || ""}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, FechaFin: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        />

        <label className="block text-gray-700 text-sm">Meta del Evento</label>
        <input
          type="number"
          className="w-full p-2 border border-gray-300 rounded"
          value={eventoSeleccionado?.meta || 0}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, meta: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        />

        <div className="flex items-center mt-2">
          <input
            type="checkbox"
            id="EvidenciaCheck"
            className="mr-2"
            checked={eventoSeleccionado?.EvidenciaCheck || false} //  Se asegura que refleje el valor correcto
            onChange={(e) =>
              setEventoSeleccionado({
                ...eventoSeleccionado,
                EvidenciaCheck: e.target.checked, //  Se actualiza correctamente en el estado
              })
            }
          />
          <label htmlFor="EvidenciaCheck" className="text-gray-700">
            ¿Requiere Evidencia?
          </label>
        </div>

        <div className="flex items-center mt-2">
          <input
            type="checkbox"
            id="EventosMasivos"
            className="mr-2"
            checked={eventoSeleccionado?.eventosMasivos || false} //  Se asegura que refleje el valor correcto
            onChange={(e) =>
              setEventoSeleccionado({
                ...eventoSeleccionado,
                eventosMasivos: e.target.checked, //  Se actualiza correctamente en el estado
              })
            }
          />
          <label htmlFor="EventosMasivos" className="text-gray-700">
            ¿Es un Evento Masivo?
          </label>
        </div>


        <label className="block text-gray-700 text-sm">Estatus</label>
        <select
          className="w-full p-2 border border-gray-300 rounded"
          value={eventoSeleccionado?.estatusEvento || "Activo"}
          onChange={(e) =>
            setEventoSeleccionado({ ...eventoSeleccionado, estatusEvento: e.target.value })
          }
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"}
        >
          <option value="Activo">Activo</option>

          <option value="Cancelado">Cancelado</option>
        </select>
      </div>

      {/* Botones de Acción */}
      <div className="mt-6 flex justify-end gap-2">
        <button
          className={`px-4 py-2 rounded ${
            eventoSeleccionado?.estatusEvento === "Finalizado"
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-500 hover:bg-green-600 text-white"
          }`}
          onClick={guardarEdicionEvento}
          disabled={eventoSeleccionado?.estatusEvento === "Finalizado"} o
        >
          Guardar Cambios
        </button>
        <button
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition"
          onClick={() => setShowEditarModal(false)}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}


{/* ASIGNACIÓN DE LIDERES */}

{showAsignarModal && (
  <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4"
    onClick={() => setShowAsignarModal(false)}
  >
    <div
      className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-2xl w-full relative text-white border border-gray-600"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Encabezado */}
      <div className="flex justify-between items-center border-b border-gray-500 pb-2">
        <h3 className="text-lg font-semibold">Asignar Líderes</h3>
        <button
          onClick={() => setShowAsignarModal(false)}
          className="text-gray-400 hover:text-white text-lg"
        >
          ✖
        </button>
      </div>

      {/* CUERPO DEL MODAL  */}
      <div className="mt-4 grid grid-cols-3 gap-4">
        {/* Lista de líderes disponibles */}
        <div className="col-span-1">
          <h6 className="text-center font-semibold text-gray-300">Líderes Disponibles</h6>
          <ul className="border border-gray-500 bg-[#0d2a3b] rounded-md p-2 max-h-60 overflow-auto">
            {lideresDisponibles.length > 0 ? (
              lideresDisponibles.map((lider) => (
                <li
                  key={lider.id}
                  className="flex justify-between items-center p-2 border-b border-gray-500 bg-[#0b2533] rounded-md"
                >
                  {lider.nombre}
                  <button
                    className="bg-blue-500 hover:bg-blue-600 text-black px-2 py-1 rounded text-sm"
                    onClick={() => moverLider(lider.id, lideresDisponibles, "asignados")}
                  >
                    ➡️
                  </button>
                </li>
              ))
            ) : (
              <p className="text-gray-400 text-sm text-center py-2">No hay líderes disponibles</p>
            )}
          </ul>
        </div>

        {/* Botones de movimiento */}
        <div className="col-span-1 flex flex-col items-center justify-center space-y-2">
          <button
            className="bg-green-500 hover:bg-green-600 text-black px-4 py-2 rounded font-semibold"
            onClick={() => moverTodos("disponibles", "asignados")}
          >
            ➡➡
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-black px-4 py-2 rounded font-semibold"
            onClick={() => moverTodos("asignados", "disponibles")}
          >
            ⬅⬅
          </button>
        </div>

        {/* Lista de líderes asignados */}
        <div className="col-span-1">
          <h6 className="text-center font-semibold text-gray-300">Líderes Asignados</h6>
          <ul className="border border-gray-500 bg-[#0d2a3b] rounded-md p-2 max-h-60 overflow-auto">
            {lideresAsignados.length > 0 ? (
              lideresAsignados.map((lider) => (
                <li
                  key={lider.id}
                  className="flex justify-between items-center p-2 border-b border-gray-500 bg-[#0b2533] rounded-md"
                >
                  {lider.nombre}
                  <button
                    className="bg-yellow-500 hover:bg-yellow-600 text-black px-2 py-1 rounded text-sm"
                    onClick={() => moverLider(lider.id, lideresAsignados, "disponibles")}
                  >
                    ⬅️
                  </button>
                </li>
              ))
            ) : (
              <p className="text-gray-400 text-sm text-center py-2">No hay líderes asignados</p>
            )}
          </ul>
        </div>
      </div>

      {/* Botones de Acción */}
      <div className="mt-6 flex justify-between">
        <button
          className="bg-red-500 hover:bg-red-600 text-black px-4 py-2 rounded font-semibold"
          onClick={quitarLiderDelEvento}
        >
          Quitar Líderes Seleccionados
        </button>
        <div className="space-x-2">
          <button
            className="bg-green-500 hover:bg-green-600 text-black px-4 py-2 rounded font-semibold"
            onClick={guardarAsignacion}
          >
            Guardar Asignación
          </button>
          <button
            className="bg-gray-500 hover:bg-gray-600 text-black px-4 py-2 rounded font-semibold"
            onClick={() => setShowAsignarModal(false)}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{showAsignarPorNivelModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm px-4">
          <div className="bg-[#081b29] p-6 rounded-lg shadow-lg max-w-2xl w-full text-white border border-gray-600">
            <div className="flex justify-between items-center border-b border-gray-500 pb-2">
              <h3 className="text-lg font-semibold">Asignar por Nivel</h3>
              <button onClick={() => setShowAsignarPorNivelModal(false)} className="text-gray-400 hover:text-white text-lg">
                ✖
              </button>
            </div>

            <div className="mt-4 space-y-3">
              <p>Selecciona los niveles a asignar:</p>
              <ul>
                {niveles.map((nivel) => (
                  <li key={nivel.id} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={nivelesSeleccionados.includes(nivel.id)}
                      onChange={() => toggleNivel(nivel.id)}
                    />
                    <span>({nivel.id}) {nivel.descripcion}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-6 flex justify-end gap-2">
              <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600" onClick={guardarAsignacionPorNivel}>
                Guardar
              </button>
              <button className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600" onClick={() => setShowAsignarPorNivelModal(false)}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

</div>



  );
};

export default AdminEventos;
